import { Fragment, useMemo } from 'react'

import { useQueryProjectMembers } from '@/requests/queries/useQueryProject.ts'
import { getInitials } from '@/utils/user.ts'

type Props = {
  targetMembers: Member[]
}

export const MemberStringList = ({ targetMembers }: Props) => {
  const { members } = useQueryProjectMembers()

  return useMemo(() => {
    const membersMap = new Map(members.map((member) => [member.id, member]))

    const result = targetMembers
      .map((member) => membersMap.get(member.id))
      .filter((member) => member !== undefined)
      .map((member, index) => (
        <Fragment key={member.id}>
          {index > 0 && <span className="text-tb-navy-900 font-EN-KR-body1-bold">, </span>}
          <span className="text-tb-blue-900 font-EN-KR-body1-bold">{getInitials(member.name)}</span>
        </Fragment>
      ))

    return result.length === 0 ? null : <span className="text-contents-primary">({result})</span>
  }, [targetMembers, members])
}
